module.exports = "/virtual-football-league/img/video/VFL_logo_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/VFL_logo_012.png
// module id = 2245
// module chunks = 4